import { Group } from '@mantine/core';
import { IconDeviceDesktop, IconUser } from '@tabler/icons-react';
import { EvidenceFieldRow } from 'components/tables/data/evidence-field/types';
import P2Regular from 'components/typography/P2Regular';

/** Renders the one exclusive evidence-field consumer. */
export default function ApplicabilityColumn({ data }: { data: EvidenceFieldRow }) {
  const people = data.appliesToPeople;
  return (
    <Group spacing={8} noWrap>
      {people ? <IconUser stroke={1.5} /> : <IconDeviceDesktop stroke={1.5} />}
      <P2Regular color="gray.8">{people ? 'Osoby' : 'Zariadenia'}</P2Regular>
    </Group>
  );
}
